import * as React from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import {
  HeaderWrapper,
  StyledHeader,
  StyledLogo,
} from "src/components/Header/Header.components";
import InGameNav from "src/components/Header/Navbars/InGameNav";
import Nav from "src/components/Header/Navbars/Nav";
import { useModal } from "src/components/shared/Modal";
import ContactModal from "src/components/Contact/ContactModal";
import {
  GAME_PATH,
  JOIN_GAME_PATH,
  MAIN_PATH,
  SUMMARY,
} from "src/utils/routesPaths";
import HamburgerButton from "../Header/HamburgerButton";

const Header: React.FunctionComponent = () => {
  const [navOpened, setNavOpened] = React.useState(false);
  const toggleNavOpen = () => setNavOpened(navOpened => !navOpened);
  const closeNav = () => setNavOpened(false);
  const { openFixedModal } = useModal();

  const location = useLocation();

  const openContactModal = React.useCallback(() => {
    closeNav();
    openFixedModal(<ContactModal />);
  }, [openFixedModal]);

  const inGameMatch = matchPath(GAME_PATH, location.pathname);

  const joinGameMatch = matchPath(JOIN_GAME_PATH, location.pathname);

  const summaryPath = matchPath(SUMMARY, location.pathname);

  if (joinGameMatch || summaryPath) {
    return null;
  }

  return (
    <StyledHeader navOpened={navOpened} data-cy="header">
      <HeaderWrapper>
        <Link aria-label="Homepage link" to={MAIN_PATH} onClick={closeNav}>
          <StyledLogo />
        </Link>
        {!inGameMatch ? (
          <Nav openContactModal={openContactModal} />
        ) : (
          <InGameNav closeNav={closeNav} openContactModal={openContactModal} />
        )}
        <HamburgerButton active={navOpened} onClick={toggleNavOpen} />
      </HeaderWrapper>
    </StyledHeader>
  );
};

export default Header;
